import Page from "../page/Page.js";
import {useContext, useEffect, useRef} from "react";
import Dropdown from "react-dropdown";
import {
  matchContent,
  percentage,
} from "../../methods/contentFormatHelpers.js";
// import AreaChart from "../AreaChart.tsx";
import { ValuationDataContext } from "../../contextProviders/ValuationDataProvider.js";
import { GlossaryContext } from "../../contextProviders/GlossaryProvider.js";
import "./pageList.css";
import {
  adjustContent,
  observer,
} from "../../methods/contentDistributionHelpers.js";
import AreaChart from "../AreaChart";
import AreaChartAnalisys from "../AreaChartAnalisys";
import AreaChartDiscountRate from "../AreaChartDiscountRate";
import useValutationData from "../../hooks/useValutationData";

const PageList = ({ refs, editable, valuationData, setValuationData, calculateSensitivityAnalysis, calculateNPVtoDiscountRate }) => {
  //const { valuationData, setValuationData, calculateSensitivityAnalysis, calculateNPVtoDiscountRate } = useContext(ValuationDataContext);
    console.log(valuationData)
  const glossary = useContext(GlossaryContext);

  useEffect(() => {
    [...document.getElementsByClassName("moveable")].forEach((elem) => {
      observer.observe(elem, { characterData: true, subtree: true });
    });
    adjustContent();
  }, []);

  const updateId = (elem) => {
    setValuationData({
      type: "update",
      payload: { id: elem.target.textContent },
    });
  }
    const getNPVDiscountRate = () => {
      const rates = [0, 0.02, 0.04, 0.06, 0.08, 0.10, 0.12, 0.14, 0.16, 0.18, 0.2, 0.22, 0.24,0.26,0.28,0.3];
      return rates.map( rate => {
          return calculateNPVtoDiscountRate(rate)
      })
    }
  return (
      <div className="page-list" ref={refs["printRef"]}>
        <Page pageIndex={1} valuation_id={valuationData.id} updateId={updateId}>
            <div className="section moveable">
                <h2 ref={refs["basicDataRef"]} className="subsection-title">
                    1. DANE PODSTAWOWE
                </h2>
                <div className="section-content"></div>
            </div>

            <div className="section moveable">
                <h3 className="section-title">Osoba opracowująca</h3>
                <div
                    id="osoba_opracowujaca"
                    onInput={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {osoba_opracowujaca: elem.target.textContent},
                        })
                    }
                    className="section-content"
                    placeholder="Proszę wpisać..."
                    contentEditable={true}
                ></div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Osoba zatwierdzająca</h3>
                <div
                    id="osoba_zatwierdzajaca"
                    onInput={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {osoba_zatwierdzajaca: elem.target.textContent},
                        })
                    }
                    className="section-content"
                    placeholder="Proszę wpisać..."
                    contentEditable={true}
                ></div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Miejscowość</h3>
                <div
                    id="miejscowosc"
                    onInput={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {miejscowosc: elem.target.textContent},
                        })
                    }
                    className="section-content"
                    placeholder="Proszę wpisać..."
                    contentEditable={true}
                ></div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Data</h3>
                <input
                    id="data_spotkania"
                    value={valuationData.data_spotkania || ""}
                    onChange={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {data_spotkania: elem.target.value},
                        })
                    }
                    type="date"
                    disabled={!editable}
                    className="section-content"
                ></input>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Opracowanie</h3>
                <Dropdown
                    disabled={!editable}
                    value={valuationData.opracowanie}
                    onChange={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {opracowanie: elem.value},
                        })
                    }
                    className="section-select"
                    controlClassName="myControlClassName"
                    arrowClassName="myArrowClassName"
                    placeholderClassName="myPlaceholderClassName"
                    menuClassName="myMenuClassName"
                    options={matchContent(glossary, "opracowanie")}
                    placeholder="Proszę wybrać..."

                />
            </div>
            <div className="section moveable">
                <h3 className="section-title">Forma stosowanej ochrony</h3>
                <Dropdown
                    disabled={!editable}
                    value={valuationData.forma_stosowanej_ochrony}
                    onChange={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {forma_stosowanej_ochrony: elem.value},
                        })
                    }
                    className="section-select"
                    controlClassName="myControlClassName"
                    arrowClassName="myArrowClassName"
                    placeholderClassName="myPlaceholderClassName"
                    menuClassName="myMenuClassName"
                    options={matchContent(glossary, "forma stosowanej ochrony")}
                    placeholder="Proszę wybrać..."
                />
            </div>
            <div className="section moveable">
                <h3 className="section-title">Numer zgłoszenia (jeśli dotyczy)</h3>
                <div
                    id="numer_zgloszenia"
                    onInput={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {numer_zgloszenia: elem.target.textContent},
                        })
                    }
                    className="section-content"
                    placeholder="Proszę wpisać..."
                    contentEditable={true}
                ></div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">
                    Numer prawa wyłącznego (jeśli dotyczy)
                </h3>
                <div
                    id="numer_prawa_wylacznego"
                    onInput={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {numer_prawa_wylacznego: elem.target.textContent},
                        })
                    }
                    className="section-content"
                    placeholder="Proszę wpisać..."
                    contentEditable={true}
                ></div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">
                    Numer wewnętrzny WI (zgodny z regulaminem wewnętrznym)
                </h3>
                <div
                    id="numer_wewnetrzny_wi"
                    onInput={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {numer_wewnetrzny_wi: elem.target.textContent},
                        })
                    }
                    className="section-content"
                    placeholder="Proszę wpisać..."
                    contentEditable={true}
                ></div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Twórcy</h3>
                <div
                    id="tworcy"
                    onInput={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {tworcy: elem.target.textContent},
                        })
                    }
                    className="section-content"
                    placeholder="Proszę wpisać..."
                    contentEditable={true}
                ></div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Podmioty uprawnione</h3>
                <div
                    id="podmioty_uprawnione"
                    onInput={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {podmioty_uprawnione: elem.target.textContent},
                        })
                    }
                    className="section-content"
                    placeholder="Proszę wpisać..."
                    contentEditable={true}
                ></div>
            </div>

            <div className="section moveable">
                <h2 ref={refs["assumptionsRef"]} className="subsection-title">
                    2. ZAŁOŻENIA OGÓLNE
                </h2>
                <div className="section-content"></div>
            </div>

            <div className="section moveable">
                <h3 className="section-title">Wycena WNiP</h3>
                <Dropdown
                    disabled={!editable}
                    value={valuationData.wycena_wnip}
                    onChange={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {wycena_wnip: elem.value},
                        })
                    }
                    className="section-select"
                    controlClassName="myControlClassName"
                    arrowClassName="myArrowClassName"
                    placeholderClassName="myPlaceholderClassName"
                    menuClassName="myMenuClassName"
                    options={matchContent(glossary, "wycena wnip")}
                    placeholder="Proszę wybrać..."
                />
            </div>
            <div className="section moveable">
                <h3 className="section-title">Tytuł</h3>
                <div
                    id="tytul"
                    onInput={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {tytul: elem.target.textContent},
                        })
                    }
                    className="section-content"
                    placeholder="Proszę wpisać..."
                    contentEditable={true}
                ></div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Portfel technologiczny</h3>
                <Dropdown
                    disabled={!editable}
                    value={valuationData.portfel_technologiczny}
                    onChange={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {portfel_technologiczny: elem.value},
                        })
                    }
                    className="section-select"
                    controlClassName="myControlClassName"
                    arrowClassName="myArrowClassName"
                    placeholderClassName="myPlaceholderClassName"
                    menuClassName="myMenuClassName"
                    options={matchContent(glossary, "portfel technologiczny")}
                    placeholder="Proszę wybrać..."
                />
            </div>
            <div className="section moveable">
                <h3 className="section-title">Charakterystyka przedmiotu wyceny</h3>
                <Dropdown
                    disabled={!editable}
                    value={valuationData.charakterystyka_przedmiotu_wyceny}
                    onChange={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {charakterystyka_przedmiotu_wyceny: elem.value},
                        })
                    }
                    className="section-select"
                    controlClassName="myControlClassName"
                    arrowClassName="myArrowClassName"
                    placeholderClassName="myPlaceholderClassName"
                    menuClassName="myMenuClassName"
                    options={matchContent(
                        glossary,
                        "charakterystyka przedmiotu wyceny"
                    )}
                    placeholder="Proszę wybrać..."
                />
            </div>
            <div className="section moveable">
                <h2 ref={refs["valuationBasisRef"]} className="subsection-title">
                    3. PODSUMOWANIE WYKONAWCZE
                </h2>
                <div className="section-content"></div>
            </div>

            <div className="section moveable">
                <h3 className="section-title">NPV [zł]</h3>
                <div id="npv" className="section-content">
                    {parseFloat(valuationData.npv[20]).toFixed(2)}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">IRR [%]</h3>
                <div id="irr" className="section-content">
                    {parseFloat(valuationData.irr_val * 100)?.toFixed(2)}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">
                    Wartość rynkowa przedmiotu transakcji przy Thumb rule [zł]
                </h3>
                <div id="wartosc_rynkowa_thumb_rule" className="section-content">
                    {parseFloat(valuationData.wartosc_rynkowa_thumb_rule)?.toFixed(2)}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">
                    Wartość w przedmiocie sprzedaży (SPP) [zł]
                </h3>
                <div id="wartosc_w_przedsprzedazy" className="section-content">
                    {valuationData.wartosc_w_przedsprzedazy.toFixed(2)}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">
                    Wartość - licencja wyłączna <br/> (LIC_WYŁ) [zł]
                </h3>
                <div id="wartosc_licencja_wylaczna" className="section-content">
                    {parseFloat(valuationData.wartosc_licencja_wylaczna)?.toFixed(2)}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">
                    Wartość - licencja niewyłączna <br/> (LIC_NIEWYŁ) [zł]
                </h3>
                <div id="wartosc_licencja_niewylaczna" className="section-content">
                    {parseFloat(valuationData.wartosc_licencja_niewylaczna)?.toFixed(2)}
                </div>
            </div>
            <div className="section moveable">
                <h2 ref={refs["assumptionsAdvancedRef"]} className="subsection-title">
                    4. ZAŁOŻENIA SZCZEGÓŁOWE
                </h2>
                <div className="section-content"></div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Podstawy wyceny</h3>
                <Dropdown
                    disabled={!editable}
                    value={valuationData.podstawy_wyceny}
                    onChange={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {podstawy_wyceny: elem.value},
                        })
                    }
                    className="section-select"
                    controlClassName="myControlClassName"
                    arrowClassName="myArrowClassName"
                    placeholderClassName="myPlaceholderClassName"
                    menuClassName="myMenuClassName"
                    options={matchContent(glossary, "podstawy wyceny")}
                    placeholder="Proszę wybrać..."
                />
            </div>
            <div className="section moveable">
                <h3 className="section-title">Cel wyceny</h3>
                <Dropdown
                    disabled={!editable}
                    value={valuationData.cel_wyceny}
                    onChange={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {cel_wyceny: elem.value},
                        })
                    }
                    className="section-select"
                    controlClassName="myControlClassName"
                    arrowClassName="myArrowClassName"
                    placeholderClassName="myPlaceholderClassName"
                    menuClassName="myMenuClassName"
                    options={matchContent(glossary, "cel wyceny")}
                    placeholder="Proszę wybrać..."
                />
            </div>
            <div className="section moveable">
                <h3 className="section-title">
                    Opis przedmiotu wyceny, <br/> kontekst produktowy
                </h3>
                <div
                    id="opis_przedmiotu_wyceny"
                    onInput={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {opis_przedmiotu_wyceny: elem.target.textContent},
                        })
                    }
                    className="section-content"
                    placeholder="Proszę wpisać..."
                    contentEditable={true}
                ></div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Analiza rynku</h3>
                <Dropdown
                    disabled={!editable}
                    value={valuationData.analiza_rynku}
                    onChange={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {analiza_rynku: elem.value},
                        })
                    }
                    className="section-select"
                    controlClassName="myControlClassName"
                    arrowClassName="myArrowClassName"
                    placeholderClassName="myPlaceholderClassName"
                    menuClassName="myMenuClassName"
                    options={matchContent(glossary, "Analiza rynku")}
                    placeholder="Proszę wybrać..."
                />
            </div>
            <div className="section moveable">
                <h3 className="section-title">Udział (IP) do generowanego zysku</h3>
                <Dropdown
                    disabled={!editable}
                    value={valuationData.udzial_ip}
                    onChange={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {udzial_ip: elem.value},
                        })
                    }
                    className="section-select"
                    controlClassName="myControlClassName"
                    arrowClassName="myArrowClassName"
                    placeholderClassName="myPlaceholderClassName"
                    menuClassName="myMenuClassName"
                    options={percentage(
                        matchContent(glossary, "udział do generowanego zysku")
                    )}
                    placeholder="Proszę wybrać..."
                />
            </div>
            <div className="section moveable">
                <h3 className="section-title">Zysk jednostkowy (IP) netto [zł]</h3>
                <div id="zysk_jednostkowy_ip" className="section-content">
                    {parseFloat(valuationData.zysk_jednostkowy_ip)?.toFixed(2)}
                </div>
            </div>
            <div className="section moveable">
                <h2 ref={refs["analyticsRef"]} className="subsection-title">
                    5. ZAŁOŻENIA ANALITYCZNE
                </h2>
                <div className="section-content"></div>
            </div>

            <div className="section moveable">
                <h3 className="section-title">Wielkość rynku docelowego [szt.]</h3>
                <div
                    id="wielkosc_rynku_docelowego_szt"
                    onInput={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {
                                wielkosc_rynku_docelowego_szt: elem.target.textContent,
                            },
                        })
                    }
                    className="section-content"
                    placeholder="Proszę wpisać..."
                    contentEditable={true}
                ></div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Nakłady inwestycyjne [zł]</h3>
                <div
                    id="naklady_inwestycyjne"
                    onInput={(elem) =>
                        setValuationData({
                            type: "update_naklady_inwestycyjne",
                            payload: {
                                naklady_inwestycyjne: elem.target.textContent,
                            },
                        })
                    }
                    className="section-content"
                    placeholder="Proszę wpisać..."
                    contentEditable={true}
                ></div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Dodatkowy sprzęt [zł]</h3>
                <div
                    id="dodatkowy_sprzet"
                    onInput={(elem) =>
                        setValuationData({
                            type: "update_srodki_trwale",
                            payload: {dodatkowy_sprzet: elem.target.textContent},
                        })
                    }
                    className="section-content"
                    placeholder="Proszę wpisać..."
                    contentEditable={true}
                ></div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Stawka amortyzacji środka trwałego [%]</h3>
                <div
                    id="stawka_amortyzacji_st"
                    onInput={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {stawka_amortyzacji_st: elem.target.textContent},
                        })
                    }
                    className="section-content"
                    placeholder="Proszę wpisać..."
                    contentEditable={true}
                ></div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Penetracja rynku "n=0" [%]</h3>
                <Dropdown
                    disabled={!editable}
                    value={valuationData.penetracja_rynku_n_0}
                    onChange={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {penetracja_rynku_n_0: elem.value},
                        })
                    }
                    className="section-select"
                    controlClassName="myControlClassName"
                    arrowClassName="myArrowClassName"
                    placeholderClassName="myPlaceholderClassName"
                    menuClassName="myMenuClassName"
                    options={percentage(matchContent(glossary, "penetracja rynku n=0"))}
                    placeholder="Proszę wybrać..."
                />
            </div>
            <div className="section moveable">
                <h3 className="section-title">Penetracja rynku "n=10" [%]</h3>
                <div
                    id="penetracja_rynku_n_10"
                    onInput={(elem) =>
                        setValuationData({
                            type: "update_penetracja_rynku_n10",
                            payload: {penetracja_rynku_n_10: elem.target.textContent},
                        })
                    }
                    className="section-content"
                    placeholder="Proszę wpisać..."
                    contentEditable={true}
                ></div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Wzrost rynku docelowego [%]</h3>
                <Dropdown
                    disabled={!editable}
                    value={valuationData.wzrost_rynku_docelowego}
                    onChange={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {wzrost_rynku_docelowego: elem.value},
                        })
                    }
                    className="section-select"
                    controlClassName="myControlClassName"
                    arrowClassName="myArrowClassName"
                    placeholderClassName="myPlaceholderClassName"
                    menuClassName="myMenuClassName"
                    options={percentage(
                        matchContent(glossary, "wzrost rynku docelowego")
                    )}
                    placeholder="Proszę wybrać..."
                />
            </div>
            <div className="section moveable">
                <h3 className="section-title">Horyzont planowania [lata]</h3>
                <Dropdown
                    disabled={!editable}
                    value={valuationData.horyzont_planowania?.toString()}
                    onChange={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {horyzont_planowania: elem.value},
                        })
                    }
                    className="section-select"
                    controlClassName="myControlClassName"
                    arrowClassName="myArrowClassName"
                    placeholderClassName="myPlaceholderClassName"
                    menuClassName="myMenuClassName"
                    options={matchContent(glossary, "horyzont planowania")}
                    placeholder="Proszę wybrać..."
                />
            </div>
            <div className="section moveable">
                <h3 className="section-title">Liniowa zmiana cen [%]</h3>
                <Dropdown
                    disabled={!editable}
                    value={valuationData.liniowa_zmiana_cen}
                    onChange={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {liniowa_zmiana_cen: elem.value},
                        })
                    }
                    className="section-select"
                    controlClassName="myControlClassName"
                    arrowClassName="myArrowClassName"
                    placeholderClassName="myPlaceholderClassName"
                    menuClassName="myMenuClassName"
                    options={percentage(matchContent(glossary, "liniowa zmiana cen"))}
                    placeholder="Proszę wybrać..."
                />
            </div>
            <div className="section moveable">
                <h3 className="section-title">Thumb rule [%]</h3>
                <div id="thumb_rule" className="section-content">
                    {percentage(matchContent(glossary, "thumb_rule"))[0]}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Rentowność branży [%]</h3>
                <div
                    id="rentownosc_branzy"
                    onInput={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {rentownosc_branzy: elem.target.textContent},
                        })
                    }
                    className="section-content"
                    placeholder="Proszę wpisać..."
                    contentEditable={true}
                ></div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Wrażliwość na zmiany</h3>
                <div
                    id="wrazliwosc_na_zmiany"
                    onInput={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {wrazliwosc_na_zmiany: elem.target.textContent},
                        })
                    }
                    className="section-content"
                    placeholder="Proszę wpisać..."
                    contentEditable={true}
                ></div>
            </div>
            <div className="section moveable">
                <h2 ref={refs["financialRef"]} className="subsection-title">
                    6. ZAŁOŻENIA FINANSOWE
                </h2>
                <div className="section-content"></div>
            </div>

            <div className="section moveable">
                <h3 className="section-title">
                    Wielkość szacowanej sprzedaży [szt.]
                </h3>
                <div
                    id="wielkosc_szacowanej_sprzedazy_szt"
                    className="section-content"
                >
                    {parseFloat(
                        valuationData.wielkosc_szacowanej_sprzedazy_szt
                    )?.toFixed(2)}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Przychody ze sprzedaży [zł]</h3>
                <div id="przychody_ze_sprzedazy_zl" className="section-content">
                    {parseFloat(valuationData.przychody_ze_sprzedazy_zl)?.toFixed(2)}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Cena jednostkowa [zł]</h3>
                <div
                    id="cena_jednostkowa_zl"
                    onInput={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {cena_jednostkowa_zl: elem.target.textContent},
                        })
                    }
                    className="section-content"
                    placeholder="Proszę wpisać..."
                    contentEditable={true}
                ></div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Zysk jednostkowy brutto [zł]</h3>
                <div id="zysk_jednostkowy_brutto" className="section-content">
                    {parseFloat(valuationData.zysk_jednostkowy_brutto)?.toFixed(2)}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Zysk jednostkowy netto [zł]</h3>
                <div id="zysk_jednostkowy_netto" className="section-content">
                    {parseFloat(valuationData.zysk_jednostkowy_netto)?.toFixed(2)}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Suma przepływów za okres analizy [zł]</h3>
                <div
                    id="suma_przeplywow_za_okres_analizy"
                    className="section-content"
                >
                    {parseFloat(
                        valuationData.suma_przeplywow_za_okres_analizy
                    )?.toFixed(2)}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Wzrost wielkości sprzedaży [%]</h3>
                <Dropdown
                    disabled={!editable}
                    value={valuationData.wzrost_wielkosci_sprzedazy}
                    onChange={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {wzrost_wielkosci_sprzedazy: elem.value},
                        })
                    }
                    className="section-select"
                    controlClassName="myControlClassName"
                    arrowClassName="myArrowClassName"
                    placeholderClassName="myPlaceholderClassName"
                    menuClassName="myMenuClassName"
                    options={percentage(
                        matchContent(glossary, "wzrost wielkosci sprzedazy")
                    )}
                    placeholder="Proszę wybrać..."
                />
            </div>
            <div className="section moveable">
                <h3 className="section-title">Koszty zmienne [%]</h3>
                <Dropdown
                    disabled={!editable}
                    value={valuationData.koszty_zmienne}
                    onChange={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {koszty_zmienne: elem.value},
                        })
                    }
                    className="section-select"
                    controlClassName="myControlClassName"
                    arrowClassName="myArrowClassName"
                    placeholderClassName="myPlaceholderClassName"
                    menuClassName="myMenuClassName"
                    options={percentage(matchContent(glossary, "koszty zmienne"))}
                    placeholder="Proszę wybrać..."
                />
            </div>
            <div className="section moveable">
                <h3 className="section-title">Koszty stałe [%]</h3>
                <div
                    id="koszty_stale"
                    onInput={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {koszty_stale: elem.target.textContent},
                        })
                    }
                    className="section-content"
                    placeholder="Proszę wpisać..."
                    contentEditable={true}
                ></div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Wskaźnik rentowności dla branży [%]</h3>
                <div id="wskaznik_rentownosci_dla_branzy" className="section-content">
                    {parseFloat(
                        valuationData.wskaznik_rentownosci_dla_branzy * 100
                    )?.toFixed(2)}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Stopa dyskontowa [%]</h3>
                <Dropdown
                    disabled={!editable}
                    value={valuationData.stopa_dyskontowa}
                    onChange={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {stopa_dyskontowa: elem.value},
                        })
                    }
                    className="section-select"
                    controlClassName="myControlClassName"
                    arrowClassName="myArrowClassName"
                    placeholderClassName="myPlaceholderClassName"
                    menuClassName="myMenuClassName"
                    options={percentage(matchContent(glossary, "stopa dyskontowa"))}
                    placeholder="Proszę wybrać..."
                />
            </div>
            <div className="section moveable">
                <h3 className="section-title">Efektywne opodatkowanie [%]</h3>
                <div
                    id="efektywne_opodatkowanie"
                    onInput={(elem) =>
                        setValuationData({
                            type: "update",
                            payload: {efektywne_opodatkowanie: elem.target.textContent},
                        })
                    }
                    className="section-content"
                    placeholder="Proszę wpisać..."
                    contentEditable={true}
                ></div>
            </div>
            <div className="section moveable">
                <h2 ref={refs["calculationsRef"]} className="subsection-title">
                    7. WYLICZENIA KOŃCOWE
                </h2>
                <div className="section-content"></div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">
                    Suma przepływów netto za okres analizy [zł] <br/> [10 lat]
                </h3>
                <div
                    id="suma_przeplywow_netto_okres_analizy_zl_10"
                    className="section-content"
                >
                    {parseFloat(
                        valuationData.przeplywy_pieniezne_netto.slice(0, 9).reduce((total, amount) => {
                            return total + amount
                        }, 0)
                    )?.toFixed(2)}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">
                    Suma przepływów netto za okres analizy [zł] <br/> [15 lat]
                </h3>
                <div
                    id="suma_przeplywow_netto_okres_analizy_zl_15"
                    className="section-content"
                >
                    {parseFloat(
                        valuationData.przeplywy_pieniezne_netto.slice(0, 14).reduce((total, amount) => {
                            return total + amount
                        }, 0)
                    )?.toFixed(2)}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">
                    Suma przepływów netto za okres analizy [zł] <br/> [20 lat]
                </h3>
                <div
                    id="suma_przeplywow_netto_okres_analizy_zl_20"
                    className="section-content"
                >
                    {parseFloat(
                        valuationData.przeplywy_pieniezne_netto.slice(0, 19).reduce((total, amount) => {
                            return total + amount
                        }, 0)
                    )?.toFixed(2)}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">
                    Zestawienie przepływów za okres analizy <br/>i wskaźnika NPV [10
                    lat]
                </h3>
                <div id="zestawienie_przeplywow_npv_10" className="section-content">
                    {parseFloat(valuationData.zestawienie_przeplywow_npv_10)?.toFixed(
                        2
                    )}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">
                    Zestawienie przepływów za okres analizy <br/>i wskaźnika NPV [15
                    lat]
                </h3>
                <div id="zestawienie_przeplywow_npv_15" className="section-content">
                    {parseFloat(valuationData.npv[14])?.toFixed(
                        2
                    )}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">
                    Zestawienie przepływów za okres analizy <br/>i wskaźnika NPV [20
                    lat]
                </h3>
                <div id="zestawienie_przeplywow_npv_20" className="section-content">
                    {parseFloat(valuationData.npv[19])?.toFixed(
                        2
                    )}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Analiza wrażliwości +10% (SPP)</h3>
                <div id="analiza_wrazliwosci_spp_plus_10" className="section-content">
                    {parseFloat(valuationData.wartosc_w_przedsprzedazy * 1.1)?.toFixed(
                        2
                    )}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Analiza wrażliwości -10% (SPP)</h3>
                <div id="analiza_wrazliwosci_spp_minus_10" className="section-content">
                    {parseFloat(valuationData.wartosc_w_przedsprzedazy * 0.9)?.toFixed(
                        2
                    )}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Analiza wrażliwości +10% (LIC_WYŁ)</h3>
                <div
                    id="analiza_wrazliwosci_lic_wyl_plus_10" className="section-content">
                    {parseFloat(valuationData.wartosc_licencja_wylaczna * 1.1)?.toFixed(
                        2
                    )}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">Analiza wrażliwości -10% (LIC_WYŁ)</h3>
                <div
                    id="analiza_wrazliwosci_lic_wyl_minus_10" className="section-content">
                    {parseFloat(valuationData.wartosc_licencja_wylaczna * 0.9)?.toFixed(
                        2
                    )}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">
                    Analiza wrażliwości +10% (LIC_NIEWYŁ)
                </h3>
                <div
                    id="analiza_wrazliwosci_lic_niewyl_plus_10" className="section-content">
                    {parseFloat(valuationData.wartosc_licencja_niewylaczna * 1.1)?.toFixed(
                        2
                    )}
                </div>
            </div>
            <div className="section moveable">
                <h3 className="section-title">
                    Analiza wrażliwości -10% (LIC_NIEWYŁ)
                </h3>
                <div
                    id="analiza_wrazliwosci_lic_niewyl_minus_10" className="section-content">
                    {parseFloat(valuationData.wartosc_licencja_niewylaczna * 0.9)?.toFixed(
                        2
                    )}
                </div>
            </div>
        </Page>
        <Page pageIndex={2} valuation_id={valuationData.id} hidePage={true} updateId={updateId}/>
        <Page pageIndex={3} valuation_id={valuationData.id} hidePage={true} updateId={updateId}/>
        <Page pageIndex={4} valuation_id={valuationData.id} hidePage={true} updateId={updateId}/>
        {/*<Page pageIndex={5} valuation_id={valuationData.id} hidePage={true} updateId={updateId}/>*/}
        {/*<Page pageIndex={6} valuation_id={valuationData.id} hidePage={true} updateId={updateId}/>*/}
        {/*<Page pageIndex={7} valuation_id={valuationData.id} hidePage={true} updateId={updateId}/>*/}
        {/*<Page pageIndex={8} valuation_id={valuationData.id} hidePage={true} updateId={updateId}/>*/}
        {/*<Page pageIndex={9} valuation_id={valuationData.id} hidePage={true} updateId={updateId}/>*/}
        <Page
            pageIndex={
                5
            }
            valuation_id={valuationData.id}
            orientation={"landscape"}
            isContentDynamic={false}
            updateId={updateId}
        >
            <AreaChart
                przeplywy_pieniezne_netto={valuationData.przeplywy_pieniezne_netto}
                npv={valuationData.npv}
            />
        </Page>
        <Page
            pageIndex={
                6
            }
            valuation_id={valuationData.id}
            orientation={"landscape"}
            isContentDynamic={false}
            updateId={updateId}
        >
            <AreaChartAnalisys npv_sale={[...Array(9)].map((_, index) => (calculateSensitivityAnalysis({
                sale: (0.8 + (0.05 * index)),
                price: 1,
                costs: 1,
                investment: 1
            }).npv[9]))} npv_price={[...Array(9)].map((_, index) => (calculateSensitivityAnalysis({
                sale: 1,
                price: (0.8 + (0.05 * index)),
                costs: 1,
                investment: 1
            }).npv[9]))} npv_costs={[...Array(9)].map((_, index) => (calculateSensitivityAnalysis({
                sale: 1,
                price: 1,
                costs: (0.8 + (0.05 * index)),
                investment: 1
            }).npv[9]))} npv_investment={[...Array(9)].map((_, index) => (calculateSensitivityAnalysis({
                sale: 1,
                price: 1,
                costs: 1,
                investment: (0.8 + (0.05 * index))
            }).npv[9]))}/>
        </Page>
        <Page
            pageIndex={
                7
            }
            valuation_id={valuationData.id}
            orientation={"landscape"}
            isContentDynamic={false}
            updateId={updateId}
        >
            <AreaChartAnalisys npv_sale={[...Array(9)].map((_, index) => (calculateSensitivityAnalysis({
                sale: (0.8 + (0.05 * index)),
                price: 1,
                costs: 1,
                investment: 1
            }).irr || 0))} npv_price={[...Array(9)].map((_, index) => (calculateSensitivityAnalysis({
                sale: 1,
                price: (0.8 + (0.05 * index)),
                costs: 1,
                investment: 1
            }).irr || 0))} npv_costs={[...Array(9)].map((_, index) => (calculateSensitivityAnalysis({
                sale: 1,
                price: 1,
                costs: (0.8 + (0.05 * index)),
                investment: 1
            }).irr || 0))} npv_investment={[...Array(9)].map((_, index) => (calculateSensitivityAnalysis({
                sale: 1,
                price: 1,
                costs: 1,
                investment: (0.8 + (0.05 * index))
            }).irr || 0))}
                               irr={true}/>
        </Page>
        <Page
            pageIndex={
                8}
            valuation_id={valuationData.id}
            orientation={"landscape"}
            isContentDynamic={false}
            updateId={updateId}>
            <AreaChartDiscountRate npv={getNPVDiscountRate()}/>
        </Page>
    </div>
  );
};

export default PageList;
